<template>
  <div id="app">
    <!-- <ScaleBox> -->
      <router-view />
    <!-- </ScaleBox> -->
  </div>
</template>

<script>
import ScaleBox from './base/ScaleBox/index'

export default {
  name: 'App',
  components: { ScaleBox },
  data(){
    return {}
  },
  watch: {
    $route: {
      handler: function (val, ol) {
      },
    },
  },
  methods: {
  },
  created() {
  }
}
</script>

<style lang='less'>
</style>



// WEBPACK FOOTER //
// src/App.vue